import React from "react";
import { Link } from "react-router-dom";

function Smartfactory(){
    return(
        <div>
        <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>SMART FACTORY</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">스마트 팩토리</li>
            </ul>
          </div>
        </div>
      </section>
              <section className="feature-style-1">
                <div className="auto-container">
                    <div className="row clearfix">
                                <div className="tab-content">
                                        <div className='tab_content_area'>
                                            <div className='tab_paragraph'>
                                                    <ul>
                                                        <li>º공장자동화(FA)를 바탕으로 MES와 POP, e-Manufacturing, Mobile-Factory 등 <b className = "blue-text">생산현장시스템 솔루션을 제공</b></li>
                                                        <li>º생산공정의 원천 데이터 추출 인프라시스템인 <b className = "blue-text">RFID시스템</b>(HW, SW)를 공급</li>
                                                    </ul>
                                            </div>
                                        </div>
                                        <div className='tab_content_area'>
                                            <div className='tab_paragraph'>
                                                    <div className='fac_paragraph'>
                                                        <div style={{paddingRight:'30px'}}>
                                                          <div className="facdesImgbox">
                                                              <div className='facdesImg'>
                                                                  <img src="/images/service/Fac/revolveArrow.png" alt=""/>
                                                                  <img src="/images/service/Fac/image42.png" alt="" />
                                                                  <img src="/images/service/Fac/image43.png" alt=""/>
                                                              </div>
                                                            </div>
                                                            <div className='facdes'>스마트팩토리솔루션 기능 고도화(ODC)</div>
                                                            <div className='facdes' style={{marginTop:'30px',marginBottom:'30px'}}>MCP 과제 수행 (MES 파트너)</div>
                                                            <ul  className='facDesUl'>
                                                                <li><b>· 현재 미라콤아이앤씨 협력 파트너사</b></li>
                                                                <li style={{textIndent:'0px'}}>- 스마트팩토리 구축사업 진행 중 (MES 구축 등)</li>
                                                                <li><b>· 2022년 Smart factory Co-work Partner 선정</b></li>
                                                                <li  style={{textIndent:'0px'}}>- ICT 기반의 지능화 생산체계를 통해 제조 경쟁력 강화</li>
                                                                <li  style={{textIndent:'0px'}}>- Nexplant MESplus 솔루션을 사용하여 제품 생산부터 자재관리, 설비관리, 품질관리 등 생산공정에서 최적의 통합관리 지원</li>
                                                            </ul>
                                                        </div>
                                                        <div className='facDesImgcard'>
                                                            <img src="/images/service/Fac/image39.png" alt="" />
                                                            <b>[RFID 시스템 구성도]</b>
                                                            <div style={{display:'flex'}}>
                                                                <img src="/images/service/Fac/image40.png" alt="" />
                                                                <img src="/images/service/Fac/image41.png" alt="" />
                                                            </div>
                                                            <b>[RFID MW 서비스 화면]</b>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                </div>
                    </div>
                </div>
            </section>
                    

        </div>
        
    );
}

export default Smartfactory;